import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { Layout } from "../components/Layout";
import { Logo } from "../components/Logo";
import { SocialLinks, FlagImage } from "../components/SocialLinks";
import { apiClient } from "../lib/api";

export default function HomePage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await apiClient.post("/newsletter", { email });
      toast.success("You're on the list. Thank you!");
      setEmail("");
    } catch (err) {
      toast.error("Please enter a valid email.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout hideFooter>
      <section
        className="relative min-h-screen flex flex-col items-center justify-center px-6 pt-24 pb-12"
        data-testid="hero-section"
      >
        <div className="max-w-md w-full flex flex-col items-center text-center">
          {/* Huge signature wordmark logo */}
          <div className="scale-in" data-testid="hero-logo-wrapper">
            <Logo size="huge" />
          </div>

          {/* Tagline */}
          <p
            className="mt-10 text-yellow-400 tracking-[0.4em] text-[11px] md:text-xs uppercase fade-up delay-1"
            data-testid="hero-tagline"
          >
            Great things are on the horizon
          </p>

          {/* Premium inline newsletter form */}
          <form
            onSubmit={submit}
            className="w-full mt-10 fade-up delay-2"
            data-testid="newsletter-form"
          >
            <div className="relative">
              <input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white/[0.08] border-[0.5px] border-white/20 rounded-full pl-6 pr-36 py-4 backdrop-blur-xl text-white placeholder:text-white/45 placeholder:text-sm focus:outline-none focus:border-yellow-400/60 focus:bg-white/[0.09] transition-all"
                data-testid="newsletter-email"
              />
              <button
                type="submit"
                disabled={submitting}
                className="absolute right-1.5 top-1.5 bottom-1.5 inline-flex items-center gap-1.5 btn-accent px-5 text-sm disabled:opacity-60"
                data-testid="newsletter-submit"
              >
                <span>{submitting ? "…" : "Subscribe"}</span>
                {!submitting && <ArrowRight size={14} />}
              </button>
            </div>
            <p className="text-white/45 text-[10px] uppercase tracking-[0.3em] pt-4">
              Sign up to receive updates and announcements
            </p>
          </form>

          {/* Social icons */}
          <SocialLinks className="mt-12 fade-up delay-3" />

          {/* US flag */}
          <div
            className="mt-12 flex justify-center fade-up delay-4"
            data-testid="us-flag"
          >
            <FlagImage className="h-16 md:h-20" />
          </div>

          {/* Copyright */}
          <p
            className="mt-10 text-white/35 text-[10px] tracking-[0.25em] uppercase fade-up delay-4"
            data-testid="home-copyright"
          >
            © 2026 Councilman Wood · All rights reserved
          </p>
        </div>
      </section>
    </Layout>
  );
}
